import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic,
  BokkzAlgDataService, BokkzJrDataService
} from "@snelstart-ventures/fiscaal/domain-logic";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SpecTrialbalanceComponent} from "../spec-trialbalance/spec-trialbalance.component";
import {SpecFormattedexplanationComponent} from "../spec-formattedexplanation/spec-formattedexplanation.component";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-eigen-vermogen-natuurlijke-personen',
  templateUrl: './spec-eigen-vermogen-natuurlijke-personen.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    SharedUiDialogModule,
    SharedUiButtonModule,
    CommonModule
  ],
  styleUrls: ['./spec-eigen-vermogen-natuurlijke-personen.component.scss']
})
export class SpecEigenVermogenNatuurlijkePersonenComponent implements OnInit, OnChanges, OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private destroy$ = new Subject<void>();
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isBalansNaResultaatbestemming = false;
  public openInfoVBalansNaResultaatbestemming = false;
  pendingValue: any;
  lastValue: any;
  public balanceSheetBeforeAfterAppropriationResultsFg = {} as FormGroup;

  public equityFg = {} as FormGroup;
  public equityDisclosureFg = {} as FormGroup;
  public equityContinuityDisclosureFg = {} as FormGroup;

  public equityBusinessNaturalPersonsFg = {} as FormGroup;
  public privateIntakesNaturalPersonsFg = {} as FormGroup;
  public privateDepositesNaturalPersonsFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public optionsVoorNaResultaatbestemming: SelectFormControlItem<string>[] = [
    {value: "VOOR", label: "Voor resultaatbestemming"},
    {value: "NA", label: "Na resultaatbestemming"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  onValueChange() {
    this.pendingValue=this.balanceSheetBeforeAfterAppropriationResultsFg.get('value')?.value;
    this.openInfoVBalansNaResultaatbestemming = true;
  }

  cancelChange() {
    this.balanceSheetBeforeAfterAppropriationResultsFg.get('value')?.setValue(this.lastValue, { emitEvent: false });
    this.openInfoVBalansNaResultaatbestemming = false;
    setTimeout(()=>{
      this.pendingValue = null;
    },250)  }

  confirmChange() {
    this.lastValue = this.pendingValue;
    this.saveForm();
    this.openInfoVBalansNaResultaatbestemming = false;
    setTimeout(()=>{
      this.pendingValue = null;
    },250)  }

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    private cdRef: ChangeDetectorRef,
    public jrLogic: BokkzJrLogic) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }
    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ]).pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });
    this.jrDataService.isBalansNaResultaatbestemming.subscribe((value) => {
      this.isBalansNaResultaatbestemming = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {

    this.balanceSheetBeforeAfterAppropriationResultsFg = this.jrDataService.createProfitAppropriationItem()
    this.equityFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();

    this.equityBusinessNaturalPersonsFg = this.jrDataService.createFormGroupBalanceItem();
    this.privateIntakesNaturalPersonsFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.privateDepositesNaturalPersonsFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();

    this.equityDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.equityContinuityDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
   }

  private patchData(value: JaarrapportageEntity) {

    const balans = value.rapportage?.jaarrekeningen?.at(0)?.balans;

    if (balans) {

      if (balans.balanceSheetBeforeAfterAppropriationResults) {
        const subItem = balans.balanceSheetBeforeAfterAppropriationResults;
        this.balanceSheetBeforeAfterAppropriationResultsFg.patchValue(subItem)
        this.lastValue = subItem.value
      }

      this.equityFg.reset();
      const eigenVermogen = balans.eigenVermogen;
      if (eigenVermogen) {

        if (eigenVermogen.equity) {
          this.equityFg.patchValue(eigenVermogen.equity, { emitEvent: false })
        }

        const tekstueel = eigenVermogen.eigenVermogenTekstueel;
        if (tekstueel) {
          if (tekstueel.equityDisclosure) {
            this.equityDisclosureFg.patchValue(tekstueel.equityDisclosure);
          }
          if (tekstueel.equityContinuityDisclosure) {
            this.equityContinuityDisclosureFg.patchValue(tekstueel.equityContinuityDisclosure);
          }
        }
      }

      const eigenVermogenNatuurlijkePersonen = balans.eigenVermogenNatuurlijkePersonen;
      if (eigenVermogenNatuurlijkePersonen) {

        this.equityBusinessNaturalPersonsFg.reset();
        if (eigenVermogenNatuurlijkePersonen.equityBusinessNaturalPersons) {
          const subItem = eigenVermogenNatuurlijkePersonen.equityBusinessNaturalPersons;
          this.equityBusinessNaturalPersonsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.equityBusinessNaturalPersonsFg.get('trialBalanceItems') as FormArray)
        }

        const priveOpnamenStortingen = eigenVermogenNatuurlijkePersonen.eigenVermogenNatuurlijkePersonenPriveOpnamenStortingen
        if (priveOpnamenStortingen) {
          if (priveOpnamenStortingen.privateIntakesNaturalPersons) {
            this.privateIntakesNaturalPersonsFg.patchValue(priveOpnamenStortingen.privateIntakesNaturalPersons);
          }
          if (priveOpnamenStortingen.privateDepositesNaturalPersons) {
            this.privateDepositesNaturalPersonsFg.patchValue(priveOpnamenStortingen.privateDepositesNaturalPersons);
          }
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {

      //let op: belangrijk i.v.m. wijzigingen VOOR/NA met autogenerared items die er autmatisch uit worden gehaald.
      while (formArray.length > lijst.length) {
        formArray.removeAt(formArray.length - 1, {emitEvent: false});
      }

      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i], {emitEvent: false});
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup, {emitEvent: false});
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.balanceSheetBeforeAfterAppropriationResultsFg.updateValueAndValidity({ emitEvent: false })
    this.equityFg.updateValueAndValidity({ emitEvent: false });
    this.equityBusinessNaturalPersonsFg.updateValueAndValidity({ emitEvent: false });
    this.privateIntakesNaturalPersonsFg.updateValueAndValidity({ emitEvent: false });
    this.privateDepositesNaturalPersonsFg.updateValueAndValidity({ emitEvent: false });

    this.equityDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.equityContinuityDisclosureFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        balans: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans,
          balanceSheetBeforeAfterAppropriationResults: {value: this.balanceSheetBeforeAfterAppropriationResultsFg.getRawValue().value},
          eigenVermogenNatuurlijkePersonen: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.eigenVermogenNatuurlijkePersonen,
            equityBusinessNaturalPersons: this.equityBusinessNaturalPersonsFg.value,
          },
          eigenVermogen: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.eigenVermogen,
            eigenVermogenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.eigenVermogen?.eigenVermogenTekstueel,
              equityDisclosure: this.equityDisclosureFg.value,
              equityContinuityDisclosure: this.equityContinuityDisclosureFg.value,
            }
          },
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    // this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogic.getCalculation(this.jrEntity);
  }
}
